import styled from 'styled-components'

export const Container = styled.div`
  display: flex;
  flex-direction: row;
  gap: ${props => props.theme.spacing.sp8};
  flex-wrap: wrap;
`
